import { Col, Flex, Row } from "antd";
import Attribute from "$components/Attribute";
import { Labels } from "$components/constants";

const AttributeForm = ({ parameters, setParameters }) => {
  return (
    <Flex justify="center">
      <Row gutter={[16, 16]} wrap={false}>
        <Labels skipRadio={true} />
        <div className="scrollable-container">
          <Col flex="200px">
            <Attribute
              key={parameters}
              object={parameters}
              onChange={(change) => setParameters({ ...parameters, ...change })}
            />
          </Col>
        </div>
      </Row>
    </Flex>
  );
};

export default AttributeForm;
